module.exports = __webpack_public_path__ + "img/hidechatgbwhatsapp.9807e309.webp";